import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css'; // Se você tiver um src/index.css, descomente esta linha
import App from './App'; // Isso vai chamar o seu App.tsx do Manus
// import reportWebVitals from './reportWebVitals'; // Descomente se quiser usar

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Se você descomentou reportWebVitals acima, descomente a linha abaixo também
// reportWebVitals();
